import { combineReducers } from "redux";

import appReducer from "./app";
import devicesReducer from "./devices";
import configReducer from "./config";
import callReducer from "./call";
import userReducer from "./user";
import chatReducer from "./chat";
import interpreterReducer from "./interpreter";
import ccModerationReducer from "./ccModeration";
import inRoomAnnoucement from "./inRoomAnnoucement";

const staticReducers = {
  app: appReducer,
  devices: devicesReducer,
  call: callReducer,
  user: userReducer,
  chat: chatReducer,
  config: configReducer,
  interpreter: interpreterReducer,
  ccModeration: ccModerationReducer,
  inRoomAnnoucement: inRoomAnnoucement,
};

export default function createReducer(asyncReducers = {}) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
}
